import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupScriptsPlugin from '@swup/scripts-plugin';
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;


Alpine.plugin(intersect);

const swup = new Swup({
  // plugins: [new SwupBodyClassPlugin()]
});

// Events
swup.on('contentReplaced', init);

// Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍'); 
  startAtTop();
  megaLoop();
}


function startAtTop() {
  l('jump to top');
  window.scrollTo(0, 0)
}


// Ref: https://www.youtube.com/watch?v=BrOjGtfr8js
// https://codepen.io/ASMR-Programming/pen/poKOJxV?editors=1100


function megaLoop() {
  // const container = document.querySelector(".featured")
  // if(container) {
  //   // container / elems
    
  //   // make clone of the current element and add after 
  //   const elems = document.querySelector(".scroll-elements")
  //   const clone = elems.cloneNode(true)
  //   const parent = elems.parentElement
  //   parent.appendChild(clone)
  //   parent.scrollTo(0, 2);

  //   container.addEventListener("scroll", (e)=> {
  //     if(Math.floor(container.offsetHeight + container.scrollTop) + 1 >= container.scrollHeight){
  //       console.log('og bottom')
  //       const elems = document.querySelector(".scroll-elements")
  //       const clone = elems.cloneNode(true)
  //       const parent = elems.parentElement
  //       parent.appendChild(clone)
  //       parent.children[0].remove()
  //     } 
  //     if(container.scrollTop == 0){
  //       const elems = document.querySelector(".scroll-elements")
  //       const clone = elems.cloneNode(true)
  //       const parent = elems.parentElement
  //       parent.insertBefore(clone, parent.firstChild)
  //       parent.scrollTo(0, elems.scrollHeight)
  //       parent.lastElementChild.remove()
  //     } 
  //   });
  // }
}

